import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { basketBannerVehicleImageClickEvent } from "../banner/banner-analytics";
import HoldingImage from "../holding-image/holding-image";
export function Image({ className , src , alt , lazy , sendDigitalDataEvent , clickable =false  }) {
    const [hasError, updateErrorState] = useState(false);
    const updateError = ()=>{
        updateErrorState(true);
    };
    const defaultImageProps = {
        className: className,
        src: src,
        alt: alt || "Image",
        loading: lazy ? "lazy" : "eager",
        onError: updateError
    };
    const imageProps = clickable ? {
        ...defaultImageProps,
        "aria-hidden": true,
        onClick: ()=>sendDigitalDataEvent(basketBannerVehicleImageClickEvent())
    } : defaultImageProps;
    const { src: imageSrc , alt: imageAlt , ...restImageProps } = imageProps;
    return !src || hasError ? /*#__PURE__*/ _jsx(HoldingImage, {
        className: className,
        text: "Image Unavailable"
    }) : /*#__PURE__*/ _jsx("img", {
        src: imageSrc,
        alt: imageAlt,
        ...restImageProps
    });
}
export default Image;
